import { useCanAssignUserAdminRoles } from '../featureAccessSettings';
import { useShowLeaderSettings } from '../leaderSettings';
import { useCurrentSessionUserField } from '../session';

type UseCanCurrentUserAccessAdminSettings = () => boolean;
export const useCanCurrentUserAccessAdminSettings: UseCanCurrentUserAccessAdminSettings = () => {
  const canAssignUserAdminRoles = useCanAssignUserAdminRoles();
  const isNetworkAdmin = useCurrentSessionUserField('isNetworkAdmin') || false;
  const showLeaderSettings = useShowLeaderSettings();

  return canAssignUserAdminRoles || showLeaderSettings || isNetworkAdmin;
};
